<div class="legend-container" *ngIf="!!dataSource?.length">
  <div class="legend-item" (click)="filterByLegend('impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'impact drivers'">
    <div class="legend-color-box" style="background-color: #DCEAF7;"></div>
    <span>Impact drivers</span>
  </div>
  <div class="legend-item" (click)="filterByLegend('non-impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'non-impact drivers'">
    <div class="legend-color-box" style="background-color: #f2f2f2;"></div>
    <span>Non Impact drivers</span>
  </div>
</div>
<div class="card  table-wrapper">
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <app-data-error *ngIf="hasError" [message]="errorMessage"></app-data-error>

  <div [ngClass]="!data?.isPagination ? 'table-container' : ''" *ngIf="!isLoading && !hasError && !!dataSource?.length">
    <table mat-table [dataSource]="data?.isPagination ? pagedData : dataSource">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th class="tableheader" mat-header-cell *matHeaderCellDef> {{ columnLabels[column] }} </th>
        <td class="tablebody" mat-cell *matCellDef="let row"> {{ row[column] }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{
      'common-background': row.option_impact_drivers?.toLowerCase() === 'impact drivers',
      'non-common-background': row.option_impact_drivers?.toLowerCase() === 'non-impact drivers'
    }">
      </tr>

    </table>
    @if (!!data?.isPagination && !!dataSource.length ) {
    <app-paginator (pageChange)="onPageChange($event)" #paginatorComp></app-paginator>
    }
  </div>
</div>